import "./src/assets/css/global.css";
import { GatsbyBrowser } from "gatsby";
import ReactModal from "react-modal";
import wrapWithProvider from "./wrap-with-provider";
import wrapPage from "./wrap-page-element";
import { loadFonts, createFontFaceDeclarations } from "design-system/src/Utils/fontLoader";
import { initDatadogLogs } from "./src/lib/datadog/initDatadogLogs";
import { initDatadogRum } from "./src/lib/datadog/initDatadogRum";
import runAfterLcp from "@src/utils/runAfterLcp";
import { ensureIcoMoonStylesheet } from "@src/lib/icomoon-stylesheet";
// import { createRoot, hydrateRoot } from "react-dom/client";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] =
  wrapWithProvider;

export const wrapPageElement = wrapPage;

// Font loading implementation
export const onClientEntry = () => {
  // a11y: react-modal must know the app root so screen readers hide main content
  // when a modal is open (DeliveryOptionsModal, Autocomplete, …).
  ReactModal.setAppElement("#___gatsby");

  // Logs applicatifs DataDog (client-side uniquement)
  initDatadogLogs();

  // RUM (Real User Monitoring) + error tracking DataDog (client-side uniquement)
  initDatadogRum();

  // LCP-FIX : CSS IcoMoon hors bundle critique — chargement async non bloquant
  // pour toutes les classes `.icon-*` (FakeBannerApp, widgets legacy, etc.).
  void ensureIcoMoonStylesheet();

  // TBT-FIX: @font-face + `document.fonts.load` après idle post-peinture — évite
  // d’empiler injection DOM / mesure fonts sur le burst parse + hydrate React
  // (TBT très variable sinon). `font-display: swap` limite la régression visuelle.
  void runAfterLcp(
    () => {
      try {
        createFontFaceDeclarations(["whitenice", "littledays"]);
        void loadFonts(["whitenice", "littledays"]);
      } catch (error) {
        console.warn("⚠️ Font loading failed:", error);
      }
    },
    { timeout: 3200, fallbackDelay: 520 }
  );

  void runAfterLcp(() => {
    void import(
      /* webpackChunkName: "rolling-start-icon-font" */
      "design-system/src/lib/svgIcon/font/rolling-start.css"
    );
  });
};

//
// Ceci est un patch pour l'erreur sur le build de production avec l'erreur React :
// > Hydration failed because the initial UI does not match what was rendered on the server.
// voir https://github.com/gatsbyjs/gatsby/discussions/31943#discussioncomment-2880513
//
// export const replaceHydrateFunction: GatsbyBrowser["replaceHydrateFunction"] =
//   () => {
//     return (element: any, container: any) => {
//       // console.log("element", element);
//       // console.log("container", container);
//       // const isL = (window?.navigator?.userAgent || "").includes("lighthouse");
//       // if (!isL) {
//       // console.log("replaceHydrateFunction", container?.id);
//       if (container.id === "___gatsby") {
//         try {
//           return hydrateRoot(container, element);
//         } catch (error) {
//           const root = createRoot(container);
//           root.render(element);
//           return root;
//         }
//       }
//       // return root;
//       // const div = document.createElement("div");
//       // div.id = "___gatsby2";
//       // const root = createRoot(div);
//       // root.render(element);
//       // console.log("div", div);
//       // }
//     };
//   };
